module.exports = __webpack_public_path__ + "static/media/popupTri.f9f2005e.png";